import React, { Suspense, lazy } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
// import * as Sentry from '@sentry/react';
import AuthUrl from './components/auth/authUrl';
import { FallbackProvider } from './components/core/LazyLoad/FallbackProvider';
import { APP_TYPES } from './apiLogic/constants';
import './style.scss';
const SentryErrorBoundary = lazy(() => import('./components/error/sentryErrorBoundary'));

const Header = lazy(() => import('./components/header/header'));
const NotFound = lazy(() => import('./components/notfound/notfound'));
const PrePayment = lazy(() => import('./components/payment/payment'));
const OrderPayment = lazy(() => import('./components/payment/payment/orderPayment'));
const PrivateRoute = lazy(() => import('./components/core/PrivateRoute'));
const NationalPenNotFound = lazy(() => import('./components/notfound/postNotFound'));

const NationalPenOrderPayment = lazy(() => import('./components/NationalPenPayment/OrderPayment/ViewPage'));
const NationalPenOrderSummaryPage = lazy(() => import('./components/NationalPenPayment/OrderPayment/Summary'));

const NationalPenInvoicePayment = lazy(() => import('./components/NationalPenPayment/InvoicePayment/LandingPage'));
const NationalPenInvoicePaymentOptionsPage = lazy(() => import('./components/NationalPenPayment/InvoicePayment/PaymentOptionsPage'));
const NationalPenInvoiceDetailPage = lazy(() => import('./components/NationalPenPayment/InvoicePayment/InvoiceDetailPage'));
const NationalPenInvoiceConfirmationPage = lazy(() => import('./components/NationalPenPayment/InvoicePayment/PaymentConfirmationPage'));

const NationalPenOneFlowPayment = lazy(() => import('./components/NationalPenPayment/OneFlowPayment/ViewPage'));
const NationalPenOneFlowSummaryPage = lazy(() => import('./components/NationalPenPayment/OneFlowPayment/Summary'));

const GoldstarNotFound = lazy(() => import('./components/notfound/goldstarOrderNotFound'));

const GoldstarOrderpayment = lazy(() => import('./components/GoldstarPayment/OrderPayment/ViewPage'));
const GoldstarOrderSummaryPage = lazy(() => import('./components/GoldstarPayment/OrderPayment/Summary'));

const GoldstarInvoicePayment = lazy(() => import('./components/GoldstarPayment/InvoicePayment/LandingPage'));
const GoldstarInvoicePaymentOptionspage = lazy(() => import('./components/GoldstarPayment/InvoicePayment/PaymentOptionsPage'));
const GoldstarInvoiceDetailPage = lazy(() => import('./components/GoldstarPayment/InvoicePayment/InvoiceDetailPage'));
const GoldstarInvoiceConfirmationPage = lazy(() => import('./components/GoldstarPayment/InvoicePayment/Summary'));

const ForTeachersOnlyNotFound = lazy(() => import('./components/notfound/ftoOrderNotFound'));

const ForTeacherOnlyOrderPayment = lazy(() => import('./components/ForTeachersOnlyPayment/OrderPayment/ViewPage'));
const ForTeacherOnlyOrderSummaryPage = lazy(() => import('./components/ForTeachersOnlyPayment/OrderPayment/Summary'));

const ForTeacherOnlyInvoicePayment = lazy(() => import('./components/ForTeachersOnlyPayment/InvoicePayment/LandingPage'));
const ForTeacherOnlyInvoicePaymentOptionspage = lazy(() => import('./components/ForTeachersOnlyPayment/InvoicePayment/PaymentOptionsPage'));
const ForTeacherOnlyInvoiceDetailPage = lazy(() => import('./components/ForTeachersOnlyPayment/InvoicePayment/InvoiceDetailPage'));
const ForTeacherOnlyInvoiceConfirmationPage = lazy(() => import('./components/ForTeachersOnlyPayment/InvoicePayment/Summary'));

export function PrePaymentApp() {
    const history = useHistory();
    return (
        <Suspense fallback={<></>}>
            <div>
                <div className='top-bar' />
                <main className='container'>
                    <Header />
                    <SentryErrorBoundary>
                        <Switch>
                            <Route path='/:locale/payment' exact onEnter={AuthUrl(history)} component={PrePayment} />
                            <Route path='/:locale/payment/:encodedId' exact onEnter={AuthUrl(history)} component={OrderPayment} />
                            <Route component={NotFound} />
                        </Switch>
                    </SentryErrorBoundary>
                </main>
            </div>
        </Suspense>
    );
}

export function NationalPenPaymentApp() {
    document.title = 'Online Payments | National Pen';
    return (
        <FallbackProvider>
            <div id='mvp' className='paymentsSelfContainer'>
                <SentryErrorBoundary>
                    <Switch>
                        <Redirect from='/' to='/notfound' exact />
                        <Redirect from='/:country/:payments/ord' to='/notfound' exact />
                        <Route path='/notfound' component={NationalPenNotFound} />
                        <PrivateRoute path='/:country/:payments/ord/:encryptedParams' exact component={NationalPenOrderPayment} />
                        <PrivateRoute path='/:country/:payments/ord/summary/:refNo' exact component={NationalPenOrderSummaryPage} />

                        <PrivateRoute path='/:country/:payments' exact component={NationalPenInvoicePayment} />
                        <PrivateRoute path='/:country/:payments/:orderId' exact component={NationalPenInvoiceDetailPage} />
                        <PrivateRoute path='/:country/:payments/options/:orderId' exact component={NationalPenInvoicePaymentOptionsPage} />
                        <PrivateRoute path='/:country/:payments/summary/:refNo' exact component={NationalPenInvoiceConfirmationPage} />

                        <PrivateRoute path='/:country/:payments/cust/:guid' exact component={NationalPenOneFlowPayment} />
                        <PrivateRoute path='/:country/:payments/cust/summary/:refNo' exact component={NationalPenOneFlowSummaryPage} />

                        <Route component={NationalPenNotFound} />
                    </Switch>
                </SentryErrorBoundary>
            </div>
        </FallbackProvider>
    );
}

export function GoldstarPaymentApp() {
    return (
        <FallbackProvider>
            <div className='paymentsSelfContainer'>
                <SentryErrorBoundary>
                    <Switch>
                        <Redirect from='/' to='/notfound' exact />
                        <Redirect from='/:country/ord' to='/notfound' exact />
                        <Route path='/notfound' component={GoldstarNotFound} />
                        <PrivateRoute path='/:country/ord/:encryptedParams' exact component={GoldstarOrderpayment} />
                        <PrivateRoute path='/:country/ord/summary/:refNo' exact component={GoldstarOrderSummaryPage} />

                        <PrivateRoute path='/:country/' exact component={GoldstarInvoicePayment} />
                        <PrivateRoute path='/:country/:encryptedParams' exact component={GoldstarInvoiceDetailPage} />
                        <PrivateRoute path='/:country/options/:encryptedParams' exact component={GoldstarInvoicePaymentOptionspage} />
                        <PrivateRoute path='/:country/summary/:refNo' exact component={GoldstarInvoiceConfirmationPage} />
                        <Route component={GoldstarNotFound} />
                    </Switch>
                </SentryErrorBoundary>
            </div>
        </FallbackProvider>
    );
}

export function ForTeachersOnlyApp() {
    return (
        <FallbackProvider>
            <div className='paymentsSelfContainer'>
                <SentryErrorBoundary>
                    <Switch>
                        <Redirect from='/' to='/notfound' exact />
                        <Redirect from='/:country/ord' to='/notfound' exact />
                        <Redirect from='/:country/ord/summary' to='/notfound' exact />
                        <Route path='/notfound' component={ForTeachersOnlyNotFound} />
                        <PrivateRoute path='/:country/ord/:encryptedParams' exact component={ForTeacherOnlyOrderPayment} /> // landing page/paid page
                        <PrivateRoute path='/:country/ord/summary/:refNo' exact component={ForTeacherOnlyOrderSummaryPage} /> summary page for order payment
 
                         //invoice payment
                        <PrivateRoute path='/:country/' exact component={ForTeacherOnlyInvoicePayment} />
                        <PrivateRoute path='/:country/:encryptedParams' exact component={ForTeacherOnlyInvoiceDetailPage} />
                        <PrivateRoute path='/:country/options/:encryptedParams' exact component={ForTeacherOnlyInvoicePaymentOptionspage} />
                        <PrivateRoute path='/:country/summary/:refNo' exact component={ForTeacherOnlyInvoiceConfirmationPage} />
                        <Route component={ForTeachersOnlyNotFound} />
                    </Switch>
                </SentryErrorBoundary>
            </div>
        </FallbackProvider>
    );
}


export default function App() {
    const COMPONENTS = {
        [APP_TYPES.PRE_PAYMENT] : <PrePaymentApp/>,
        [APP_TYPES.ORDER_PAYMENT]: <PrePaymentApp/>,
        [APP_TYPES.NEW_ORDER_PAYMENT]: <NationalPenPaymentApp/>,
        [APP_TYPES.INVOICE_POST_PAYMENT]: <NationalPenPaymentApp/>,
        [APP_TYPES.ONE_FLOW_PAYMENT]: <NationalPenPaymentApp/>,
        [APP_TYPES.SIMPLY_GOLDSTAR]: <GoldstarPaymentApp/>,
        [APP_TYPES.FOR_TEACHERS_ONLY]: <ForTeachersOnlyApp/>
    }

    return COMPONENTS[window.$appName];
}
